import { ToggleGroupRoot } from './ToggleGroupRoot'

export const ToggleGroup = {
  Root: ToggleGroupRoot
}
